import axios from 'axios';
import {clearAlerts, setAlert} from './alert';
import {
    ADD_SALE,
    CLEAR_ERRORS, GET_CLIENT_OPTIONS, GET_MATERIAL_OPTIONS,
    GET_PRODUCT_CLIENT_AND_SELLER_ID_DATA, GET_PRODUCT_OPTIONS,
    GET_SALE,
    GET_SALES, GET_SPECIAL_CLIENT, PRODUCT_ERROR,
    REMOVE_DELETE_SALE,
    REMOVE_UPDATE_SALE,
    SALE_ERROR,
    SET_DELETE_SALE_ID,
    SET_UPDATE_SALE_ID
} from './types';

export const getProductClientSellerIdData = () => async (dispatch) => {

    try {
        const res = await axios.get(`/products?is_all=true`);
        const res2 = await axios.get(`/clients?is_all=true`);
        const res3 = await axios.get(`/users?is_all=true`);

        dispatch({
            type: GET_PRODUCT_CLIENT_AND_SELLER_ID_DATA,
            payload: {
                product_ID_DATA: res.data.data,
                client_ID_DATA: res2.data.data,
                seller_ID_DATA: res3.data.data,
            },
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const getProductOptions = (filters = {}) => async (dispatch) => {
    let queryParams = '';
    if (filters) {
        Object.keys(filters).map((key, index) => queryParams += `&${key}=${filters[key]}`);
    }
    try {
        const res = await axios.get(`/products?is_all=true${queryParams}`);
        dispatch({
            type: GET_PRODUCT_OPTIONS,
            payload: res.data,
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const getClientOptions = (filters = {}) => async (dispatch) => {
    try {
        let queryParams = '';
        if (filters) {
            Object.keys(filters).map((key, index) => queryParams += `&${key}=${filters[key]}`);
        }
        const res = await axios.get(`/clients?is_all=true${queryParams}`);
        dispatch({
            type: GET_CLIENT_OPTIONS,
            payload: res.data,
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const getSale = (saleID) => async (dispatch) => {

    try {
        const res = await axios.get(`/sales/${saleID}`);
        dispatch({
            type: GET_SALE,
            payload: res.data,
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const getSpecialClientMaterialTransactions = (id) => async (dispatch) => {

    try {
        const res = await axios.get(`/clients/${id}?is_special_client=true`);
        dispatch({
            type: GET_SPECIAL_CLIENT,
            payload: res.data,
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const getSales = (page = 1, filters = {}) => async (dispatch) => {
    try {

        let queryParams = '';
        if (filters) {
            Object.keys(filters).map((key, index) => queryParams += `&${key}=${filters[key]}`);
        }
        const res = await axios.get(`/sales?page=${page}${queryParams}`);

        dispatch({
            type: GET_SALES,
            payload: res.data,
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const addSale = (formData) => async (dispatch) => {
    dispatch(clearAlerts());

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        let url = '/sales/';
        if (formData?.is_special_sale === 1) {
            url += 'special';
        }
        const res = await axios.post(url, formData, config);

        dispatch(getSales());

        dispatch({
            type: ADD_SALE,
            payload: res.data,
        });

        dispatch(setAlert('Sotish yaratildi !', 'success'));

        return true;
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));

        if (err?.response?.data?.errors) {
            dispatch({
                type: SALE_ERROR,
                payload: err.response.data,
            });
            return err.response.data;
        } else {
            dispatch(setAlert("Sotish yaratilmadi !", 'danger'));
        }
    }
};

export const deleteSale = (deleteSaleID, getPage) => async (dispatch) => {
    dispatch(clearAlerts());

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res = await axios.delete(`/sales/${deleteSaleID}`, config);

        dispatch({
            type: REMOVE_DELETE_SALE
        });

        dispatch(getSales(getPage));

        dispatch(setAlert("Sotish o'chirildi !", 'success'));

        dispatch(clearErrors());
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const updateSale = (updateSaleID, updateformData, getPage) => async (dispatch) => {
    dispatch(clearAlerts());

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res = await axios.put(`/sales/${updateSaleID}`, updateformData, config);

        dispatch({type: REMOVE_UPDATE_SALE});

        dispatch(getSales(getPage));

        dispatch(setAlert('Sotish tahrirlandi !', 'success'));
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
        dispatch({
            type: SALE_ERROR,
            payload: {msg: err.response.statusText, status: err.response.status},
        });
    }
};

export const setDeleteSaleId = (saleID) => async (dispatch) => {

    try {
        if (saleID !== null) {
            dispatch({
                type: SET_DELETE_SALE_ID,
                payload: {
                    saleID
                }
            });

        } else {
            dispatch({
                type: REMOVE_DELETE_SALE
            });
        }

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const setUpdateSaleId = (saleID) => async (dispatch) => {

    try {
        if (saleID !== null) {
            dispatch({
                type: SET_UPDATE_SALE_ID,
                payload: {
                    saleID
                }
            });
        } else dispatch({type: REMOVE_UPDATE_SALE});

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};


export const clearErrors = () => async (dispatch) => {
    dispatch({
        type: CLEAR_ERRORS,
    });
};







